import styled, { css } from 'styled-components'

import breakpoints from '../../theme/breakpoints'
import fonts from '../../theme/fonts'

export const Container = styled.div<{ $isCentered?: boolean }>`
  ${({ $isCentered }) =>
    $isCentered &&
    css`
      text-align: center;
    `};
`

export const Title = styled.p`
  ${({ theme }) => theme.textStyles.titleH1};
  color: ${({ theme }) => theme.colors.pureBlack};
  margin: 2rem 0;

  ${breakpoints.down('tablet')} {
    font-size: 22px;
  }
`

export const ImageDescription = styled.div`
  margin: 2rem 0;
  ${({ theme }) => theme.textStyles.text};
  color: ${({ theme }) => theme.colors.pureBlack};
  text-align: center;

  bold,
  strong {
    ${fonts.UniversBoldCondensed}
    font-size: 18px;
    line-height: initial;
  }

  ${breakpoints.down('tablet')} {
    font-size: 22px;
  }
`

export const Description = styled.p`
  ${({ theme }) => theme.textStyles.body};
  color: ${({ theme }) => theme.colors.pureBlack};
  margin-top: 20px;
`

export const Image = styled.img`
  width: 100%;
  vertical-align: middle;
`
